/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "DATA_ANALYTICS/LOADER_STATUS";
export const PROFILE_INFO = "TURNOVER/PROFILE_INFO";
export const SET_VARIANCE_DATA = "TURNOVER/SET_VARIANCE_DATA";

export const SET_RCHRGE_DATA = "TURNOVER/SET_RCHRGE_DATA";
export const SET_TAX_DATA = "TURNOVER/SET_TAX_DATA";
export const SET_TURNOVER_DATA = "TURNOVER/SET_TURNOVER_DATA";
export const SET_TAXRATE_DATA = "TURNOVER/SET_TAXRATE_DATA";
export const SET_GSTR1_NIL_DATA = "TURNOVER/SET_GSTR1_NIL_DATA";
export const SET_CLEAR_GRAPH = "TURNOVER/SET_CLEAR_GRAPH";
